import { DriverListOrderByOptions } from "../models/api/admin/driver";

/**
 * Helper function to handle special sorting for LastChecked and NextCheck columns
 *
 * @param orderBy The column to sort by
 * @param sortOrder The sort direction ('asc' or 'desc')
 * @returns Object to be spread into the API request body
 */
export const createDriverTableSortingProperties = (
    orderBy: string,
    sortOrder: string
): { orderBy?: string; LicenceCheckOrderBy?: any } => {
    if (
        orderBy === DriverListOrderByOptions.LastChecked ||
        orderBy === DriverListOrderByOptions.NextCheck
    ) {
        return {
            LicenceCheckOrderBy: {
                // Set the appropriate column to true
                [orderBy]: true,
                IsAscending: sortOrder.toLowerCase() === "asc",
            },
        };
    }

    // For all other columns, return the standard orderBy format
    return {
        orderBy: `${orderBy} ${sortOrder}`,
    };
};
